import { render, staticRenderFns } from "./editDiy.vue?vue&type=template&id=4cc4b05e&scoped=true"
import script from "./editDiy.vue?vue&type=script&lang=js"
export * from "./editDiy.vue?vue&type=script&lang=js"
import style0 from "./editDiy.vue?vue&type=style&index=0&id=4cc4b05e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc4b05e",
  null
  
)

export default component.exports